import * as actionTypes from './action-types'

export const logout = () => ({
  type: actionTypes.LOGOUT,
})

export const getStoredAccessToken = () => ({
  type: actionTypes.GET_STORED_TOKEN,
})

export const checkActiveModule = () => ({
  type: actionTypes.CHECK_ACTIVE_MODULE,
})
